import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CSSProperties } from '@mui/material/styles';
import React from 'react';
import SvgErrorOutline from '../Icons/ErrorOutline';
import { Done } from '@mui/icons-material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import SvgInfo from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';

export interface InfoBarProps extends CSSProperties {
  info: string | React.ReactNode;
  type: 'Info' | 'Error' | 'Success';
  height?: string;
  width?: string;
  infoIcon?: boolean;
}

const InfoBar: React.FC<InfoBarProps> = ({ info, type, height, width }) => {
  const iconStyles = {
    height: '16px',
    width: '16px',
    margin: '2px 8px 0px 12px',
  };

  const getProperties = () => {
    switch (type) {
      case 'Info':
        return {
          background: patientAccessTheme.palette.chips?.background3,
          color: patientAccessTheme.palette.chips.textColor3,
          icon: <SvgInfo style={{ ...iconStyles }} />,
        };
      case 'Error':
        return {
          background: patientAccessTheme.palette.AIQChips?.background1,
          color: patientAccessTheme.palette.chips?.textColor4,
          icon: <SvgErrorOutline fill="#D6545E" style={iconStyles} />,
        };
      case 'Success':
        return {
          background: patientAccessTheme.palette.AIQChips?.background2,
          color: patientAccessTheme.palette.AIQChips?.textColor2,
          icon: (
            <Done
              style={{
                fill: patientAccessTheme.palette.AIQChips?.textColor2,
                ...iconStyles,
              }}
            />
          ),
        };
      default:
        return {};
    }
  };

  const { background, color, icon } = getProperties();

  const useStyles = makeStyles()({
    root: {
      maxWidth: width ?? '350px',
      height: height ?? 'auto',
      background: background,
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '8px',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'flex-start',
      margin: '0px 0px 16px 0px',
      padding: '4px',
    },
    icon: {
      flexShrink: 0,
    },
    text: {
      flex: 1,
      minWidth: 0,
    },
  });

  const { classes } = useStyles();

  return (
    <Grid container className={classes.root}>
      <Grid className={classes.icon}>{icon}</Grid>
      <Grid className={classes.text}>
        <Typography fontSize="12px" lineHeight="22px" textColor={color}>
          {info}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default InfoBar;
